// extracted by mini-css-extract-plugin
export default {"layout":"_13253d0caa _2bb20c85b8 _80986b6099","h_slide":"_6c36215d04","category":"_7a5e050f9b c9b0cfa621 d2f084007c"};